import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CallHttpService } from './call-http.service';
import { AdministratorEntity } from '../model/administrator/AdministratorEntity';
import { AcademyAdministratorOperation } from '../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/administrator/AcademyAdministratorType';
import { BulkMemberUpdate } from '../model/bulk/BulkMemberUpdate';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(
    private callHttpService: CallHttpService
  ) { }

  /**
   * Actualiza masivamente el estado de los miembros.
   * Llama directamente al api de "gestion" (fn-lipatin-carnetdigital-membership)
   * porque ahí es donde está desplegada la function MembersMassive.
   * @param bulkUpdate Datos para la actualización masiva
   * @returns Observable con la respuesta del servidor (retorna jobId inmediatamente)
   */
  bulkUpdateMembers(bulkUpdate: BulkMemberUpdate): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.BULK_UPDATE,
      payload: bulkUpdate,
      type: AcademyAdministratorType.MEMBERS_MASSIVE
    };
    const url = `${environment.academyApi.gestion}/MembersMassive`;
    return this.callHttpService.post(url, entity);
  }

  /**
   * Consulta el estado de un job de actualización masiva
   * @param jobId ID del job a consultar
   * @returns Observable con el estado actual del job
   */
  getJobStatus(jobId: string): Observable<any> {
    const url = `${environment.academyApi.gestion}/MembersMassive/status/${jobId}`;
    return this.callHttpService.get(url);
  }
}
